const md5 = require('md5');

export default (context, inject) => {
	inject('redirHash', string => {
		return md5(string + context.app.$env.REDIR_SEED);
	});
};
